<template>
  <v-app>
    <v-app-bar app color="white">
      <div style="min-width: 20%" class="d-flex align-center">
        <v-app-bar-nav-icon
          @click="drawer = !drawer"
          small
        ></v-app-bar-nav-icon>
        <v-toolbar-title>
          <v-toolbar-title class="fs-14px">
            {{ $route.meta.pageName }}
          </v-toolbar-title>
        </v-toolbar-title>
      </div>
      <v-spacer></v-spacer>
      <div style="min-width: 20%" class="d-flex align-center justify-end">
        <span class="fs-14px font-weight-medium">{{ user.name }}</span>

        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" small>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <a
              :href="accountLink()"
              class="v-list-item v-list-item--link theme--light"
              tabindex="0"
              role="menuitem"
            >
              <div class="v-list-item__title">
                {{ $t("Đổi mật khẩu") }}
              </div>
            </a>

            <v-list-item @click="logout">
              <v-list-item-title>{{ $t("Đăng xuất") }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app>
      <v-toolbar elevation="4" light>
        <a href="/">
          <img
            :src="require('@/assets/common/logo.png')"
            style="height: 35px"
            class="mt-2"
            alt=""
          />
        </a>
      </v-toolbar>

      <v-divider></v-divider>

      <template v-if="items.length > 0">
        <v-subheader
          class="purple--text"
          v-if="
            checkPermission([
              'e_rent_branch',
              'e_rent_delivery',
              'e_delivery',
              'e_exchange',
              'e_prepair',
              'e_renewal',
              'e_settlement',
              'e_order',
              'e_account',
              'e_delivery_request',
              'e_dashboard',
              'e_print_pdf',
              'e_generate_stamp',
              'e_timekeeping',
            ])
          "
        >
          {{ $t("Cửa hàng") }}
        </v-subheader>

        <v-list dense>
          <div v-for="(item, index) in items" :key="`i_${index}_${item.title}`">
            <template v-if="checkMenuItem(item)">
              <!-- item group -->
              <v-list-group v-if="item.children">
                <template v-slot:prependIcon>
                  <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
                  <img v-if="item.img" :src="item.img" width="24px" alt="" />
                </template>
                <template v-slot:activator>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </template>

                <!-- item group child -->
                <div v-for="child in item.children" :key="child.title">
                  <v-list-item
                    v-if="checkMenuItem(child)"
                    :to="{ name: child.route }"
                    :disabled="!checkMenuItem(child) || child.disabled"
                  >
                    <!--  -->
                    <v-list-item-icon>
                      <v-icon v-if="child.icon">{{ child.icon }}</v-icon>
                      <img
                        v-if="child.img"
                        :src="child.img"
                        width="24px"
                        alt=""
                      />
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title>
                        {{ child.title }}
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-icon
                      v-if="item.elCountName && menuCount[item.elCountName]"
                    >
                      <v-badge
                        color="error"
                        :content="menuCount[item.elCountName]"
                        inline
                      ></v-badge>
                    </v-list-item-icon>

                    <v-list-item-icon>
                      <v-icon v-if="child.appendIcon">
                        {{ child.appendIcon }}
                      </v-icon>
                      <img
                        v-if="child.appendImg"
                        :src="child.appendImg"
                        width="24px"
                        alt=""
                      />
                    </v-list-item-icon>
                  </v-list-item>
                </div>
              </v-list-group>
              <!-- end item group -->

              <!-- item -->
              <v-list-item
                v-else
                link
                :to="{ name: item.route }"
                @click="checkRoute(item.route)"
                :disabled="!checkMenuItem(item) || item.disabled"
              >
                <v-list-item-icon>
                  <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
                  <img v-if="item.img" :src="item.img" width="24px" alt="" />
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>

                <v-list-item-icon
                  v-if="item.elCountName && menuCount[item.elCountName]"
                >
                  <v-badge
                    color="error"
                    :content="menuCount[item.elCountName]"
                    inline
                  ></v-badge>
                </v-list-item-icon>
              </v-list-item>
              <!-- end item -->
            </template>
          </div>
        </v-list>

        <v-subheader
          class="purple--text"
          v-if="
            checkPermission([
              'rent_collaborator',
              'rent_collaborator_offline',
              'rent_agency',
              'rent_contract',
            ])
          "
        >
          {{ $t("Đối tác - CTV") }}
        </v-subheader>
        <v-list dense>
          <div
            v-for="(item, index) in partnerItems"
            :key="`pi_${index}_${item.title}`"
          >
            <template v-if="checkMenuItem(item)">
              <!-- item group -->
              <v-list-group v-if="item.children">
                <template v-slot:prependIcon>
                  <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
                  <img v-if="item.img" :src="item.img" width="24px" alt="" />
                </template>
                <template v-slot:activator>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </template>

                <!-- item group child -->
                <div v-for="child in item.children" :key="child.title">
                  <v-list-item
                    v-if="checkMenuItem(child)"
                    :to="{ name: child.route }"
                    :disabled="!checkMenuItem(child) || child.disabled"
                  >
                    <!--  -->
                    <v-list-item-icon>
                      <v-icon v-if="child.icon">{{ child.icon }}</v-icon>
                      <img
                        v-if="child.img"
                        :src="child.img"
                        width="24px"
                        alt=""
                      />
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title>
                        {{ child.title }}
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-icon
                      v-if="item.elCountName && menuCount[item.elCountName]"
                    >
                      <v-badge
                        color="error"
                        :content="menuCount[item.elCountName]"
                        inline
                      ></v-badge>
                    </v-list-item-icon>

                    <v-list-item-icon>
                      <v-icon v-if="child.appendIcon">
                        {{ child.appendIcon }}
                      </v-icon>
                      <img
                        v-if="child.appendImg"
                        :src="child.appendImg"
                        width="24px"
                        alt=""
                      />
                    </v-list-item-icon>
                  </v-list-item>
                </div>
              </v-list-group>
              <!-- end item group -->

              <!-- item -->
              <v-list-item
                v-else
                link
                :to="{ name: item.route }"
                @click="checkRoute(item.route)"
                :disabled="!checkMenuItem(item) || item.disabled"
              >
                <v-list-item-icon>
                  <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
                  <img v-if="item.img" :src="item.img" width="24px" alt="" />
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>

                <v-list-item-icon
                  v-if="item.elCountName && menuCount[item.elCountName]"
                >
                  <v-badge
                    color="error"
                    :content="menuCount[item.elCountName]"
                    inline
                  ></v-badge>
                </v-list-item-icon>
              </v-list-item>
              <!-- end item -->
            </template>
          </div>
        </v-list>
      </template>
    </v-navigation-drawer>

    <v-main :class="{ 'drawer-display': !isMobileAgent() && drawer }">
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>

    <!-- audio list -->
    <audio id="error_sound_player">
      <source type="audio/wav" :src="require('@/assets/audio/error.wav')" />
    </audio>
    <audio id="success_sound_player">
      <source type="audio/wav" :src="require('@/assets/audio/success.wav')" />
    </audio>
    <audio
      :id="`notifcation_${notifcationSound}_player`"
      v-for="notifcationSound in notifcationSounds"
      :key="`ns_${notifcationSound}`"
    >
      <source
        type="audio/wav"
        :src="require(`@/assets/audio/notification_${notifcationSound}.wav`)"
      />
    </audio>
  </v-app>
</template>

<script>
import { httpClient } from "@/libs/http";
import { httpNoLoading } from "@/libs/httpNoLoading";
import { debounce } from "lodash/function";
import { NOTIFICATION_TYPE_TEXT } from "@/libs/const";

export default {
  name: "App",

  components: {},

  data: () => ({
    drawer: false,
    items: [],
    user: {},
    menuCount: {},
    notifcationSounds: [1, 2, 3],
  }),
  computed: {
    rows() {
      return [];
    },
  },
  watch: {
    $route() {
      if (this.dialogDashboard) {
        this.dialogDashboard = false;
      }
    },
  },
  created() {
    this.items = [
      {
        title: this.$t("Chấm công"),
        img: require("@/assets/sidebars/chamcong.png"),
        route: "Timekeeping",
        active: false,
        permissions: [
          "e_rent_branch",
          "e_rent_delivery",
          "e_exchange",
          "e_prepair",
          "e_renewal",
          "e_settlement",
          "e_order",
          "e_account",
          "e_delivery_request",
          "e_dashboard",
          "e_print_pdf",
          "e_generate_stamp",
          "e_timekeeping",
          "e_invoice",
          "e_delivery",
          "e_inventory",
        ],
      },
      {
        title: this.$t("Cho thuê"),
        img: require("@/assets/sidebars/thue.png"),
        route: "RentBranch",
        active: false,
        permissions: ["e_rent_branch"],
      },
      {
        title: this.$t("Đặt hộ xe"),
        img: require("@/assets/sidebars/dat_xe_hd.png"),
        route: "RentSupport",
        active: false,
        permissions: ["rent_support"],
      },
      {
        title: this.$t("Giao đi - Lấy về - Thu hồi"),
        img: require("@/assets/sidebars/giaotannoi.png"),
        route: "RentDelivery",
        active: false,
        permissions: ["e_rent_delivery", "e_delivery"],
        elCountName: "count_delivery_request",
      },
      {
        title: this.$t("Giao xe tại cửa hàng"),
        img: require("@/assets/sidebars/giao_tai_cs.png"),
        route: "BranchDelivery",
        active: false,
        permissions: ["e_rent_branch", "e_rent_delivery", "e_delivery"],
        elCountName: "count_delivery_request_branch",
      },
      {
        title: this.$t("Đổi xe"),
        img: require("@/assets/sidebars/doitra.png"),
        route: "Exchange",
        active: false,
        permissions: ["e_exchange"],
      },
      {
        title: this.$t("Chuẩn bị"),
        img: require("@/assets/sidebars/chuanbi.png"),
        route: "Prepair",
        active: false,
        permissions: ["e_prepair"],
      },
      {
        title: this.$t("Gia hạn"),
        img: require("@/assets/sidebars/giahan.png"),
        route: "Renewal",
        active: false,
        permissions: ["e_renewal"],
      },
      {
        title: this.$t("Trả xe"),
        img: require("@/assets/sidebars/hoantat.png"),
        route: "Settlement",
        active: false,
        permissions: ["e_settlement"],
      },
      {
        title: this.$t("Đơn hàng"),
        img: require("@/assets/sidebars/hoadon.png"),
        route: "Order",
        active: false,
        permissions: ["e_order"],
      },
      {
        title: this.$t("Cần xử lý"),
        img: require("@/assets/sidebars/canxuly.png"),
        route: "DeliveryRequest",
        active: false,
        permissions: ["e_delivery_request"],
      },
      {
        title: this.$t("Tài khoản"),
        img: require("@/assets/sidebars/nhanvien.png"),
        route: "Account",
        active: false,
        permissions: ["e_account"],
      },
      {
        title: this.$t("Dashboard"),
        img: require("@/assets/sidebars/dashboard.png"),
        route: "Dashboard",
        active: false,
        permissions: ["e_dashboard"],
      },
      {
        title: this.$t("In hợp đồng - phụ lục"),
        img: require("@/assets/sidebars/in_hd.png"),
        route: "PrintPDF",
        active: false,
        permissions: ["e_print_pdf"],
      },
      {
        title: this.$t("Tạo tem"),
        img: require("@/assets/sidebars/inpdf.png"),
        route: "GeneratePDF",
        active: false,
        permissions: ["e_generate_stamp"],
      },
      {
        title: this.$t("Hóa đơn"),
        img: require("@/assets/sidebars/hoadon.png"),
        route: "Invoice",
        active: false,
        permissions: ["e_invoice"],
      },
      {
        title: this.$t("Kiểm kê"),
        img: require("@/assets/sidebars/inventory.png"),
        route: "Inventory",
        active: false,
        permissions: ["e_inventory"],
      },
      {
        title: this.$t("Lương"),
        img: require("@/assets/sidebars/csgia.png"),
        route: "Payroll",
        active: false,
        permissions: ["e_payroll"],
      },
    ];
    this.partnerItems = [
      {
        title: this.$t("Đặt xe"),
        img: require("@/assets/sidebars/dat_xe_ctv.png"),
        route: "RentCollaborator",
        active: false,
        permissions: ["rent_collaborator"],
      },
      {
        title: this.$t("Đặt xe"),
        img: require("@/assets/sidebars/datxe_ctv_offline.png"),
        route: "RentCollaboratorOffline",
        active: false,
        permissions: ["rent_collaborator_offline"],
      },
      {
        title: this.$t("Đặt xe"),
        img: require("@/assets/sidebars/dat_xe_dai_ly.png"),
        route: "RentAgency",
        active: false,
        permissions: ["rent_agency"],
      },
      {
        title: this.$t("Đặt xe"),
        img: require("@/assets/sidebars/dat_xe_hd.png"),
        route: "RentContract",
        active: false,
        permissions: ["rent_contract"],
      },
      {
        title: this.$t("Trả xe"),
        img: require("@/assets/sidebars/traxe_ctv.png"),
        route: "DeliveryRequestPartner",
        active: false,
        permissions: [
          "rent_collaborator",
          "rent_collaborator_offline",
          "rent_agency",
          "rent_contract",
        ],
      },
      {
        title: this.$t("Gia hạn"),
        img: require("@/assets/sidebars/giahan.png"),
        route: "RenewalPartner",
        active: false,
        permissions: [
          "rent_collaborator",
          "rent_collaborator_offline",
          "rent_agency",
          "rent_contract",
        ],
      },
      {
        title: this.$t("Đơn hàng"),
        img: require("@/assets/sidebars/hoadon.png"),
        route: "OrderPartner",
        active: false,
        permissions: [
          "rent_collaborator",
          "rent_collaborator_offline",
          "rent_agency",
          "rent_contract",
        ],
      },
      {
        title: this.$t("Chính sách hoa hồng"),
        img: require("@/assets/sidebars/commission.png"),
        route: "CommissionPolicy",
        active: false,
        permissions: [
          "rent_collaborator",
          "rent_collaborator_offline",
          "rent_agency",
        ],
      },
      {
        title: this.$t("Bảng giá"),
        img: require("@/assets/sidebars/csgia.png"),
        route: "PriceContract",
        active: false,
        permissions: ["rent_contract"],
      },
    ];
  },
  mounted() {
    window.exportWaiting = false;
    const user = window.me;
    this.user = { ...user };
    this.menuCount = {
      count_delivery_request: user.count_delivery_request,
      count_delivery_request_branch: user.count_delivery_request_branch,
    };

    window.socket.on("auth", (data) => {
      console.log(data);
    });
    window.socket.emit("auth", user.key, "employee");

    this.$root.$on("onLogout", this.logout);

    this.checkLocationPermission();

    this.listenSocket();
  },
  beforeDestroy() {
    this.$root.$off("onLogout", this.logout);
  },
  methods: {
    checkMenuItem(item) {
      return (
        (!item.permissions ||
          item.permissions.length === 0 ||
          this.checkPermission(item.permissions)) &&
        (!item.modules ||
          item.modules.length === 0 ||
          this.checkModule(item.modules)) &&
        this.checkMenuMobile(item.mobileCheck) &&
        this.checkMenuDesktop(item.desktopCheck)
      );
    },
    async logout() {
      await httpClient.post("/me/v1/logout");
      localStorage.removeItem("_sit");
      window.location = process.env.VUE_APP_HOME_PATH;
      return true;
    },
    checkRoute(routeName) {
      if (this.$route.name === routeName) {
        window.location.reload();
      }
    },
    accountLink() {
      if (!this.user.id) {
        return "";
      }
      return "/change-password";
    },
    onNotifyChange(count) {
      this.notifyCount = count;
    },
    changeLanguage(lang) {
      localStorage.setItem("_lang", lang);
      window.location.reload();
    },
    checkLocationPermission() {
      navigator.permissions
        .query({ name: "geolocation" })
        .then((permissionStatus) => {
          if (permissionStatus.state === "granted") {
            this.startTracking();
          } else if (permissionStatus.state === "prompt") {
            this.requestLocation();
          } else {
            this.$vToastify.warning("Location Permission Denied");
          }
        });

      if ("Notification" in window && Notification.permission != "granted") {
        Notification.requestPermission().then((permission) => {
          if (permission != "granted") {
            this.$vToastify.warning("Notification Permission Denied");
          }
        });
      }
    },

    listenSocket() {
      window.socket.on("notification_push", (data) => {
        console.log("listenSocket->notification_push->data", data);

        const { type, message } = data;

        if (Notification.permission == "granted") {
          const typeTxt = NOTIFICATION_TYPE_TEXT[type];
          new Notification(typeTxt, {
            body: message,
            icon: require("@/assets/common/logo-sm.png"),
          });
        }

        console.log(`notifcation_${type}_player`);
        document.getElementById(`notifcation_${type}_player`).play();
      });
    },

    requestLocation() {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log("requestLocation->position", position);
          this.startTracking();
        },
        (error) => {
          console.log("requestLocation->error", error);
        }
      );
    },
    startTracking() {
      navigator.geolocation.watchPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          this.sendLocation({ latitude, longitude });
        },
        (error) => {
          console.error("Error watching position:", error);
        },
        {
          enableHighAccuracy: true,
          maximumAge: 60000,
          timeout: 5000,
        }
      );
    },
    sendLocation: debounce(function ({ latitude, longitude }) {
      if (!this.checkPermission(["e_rent_delivery", "e_delivery"])) {
        return false;
      }

      httpNoLoading.post("/common/v1/send-location", {
        latitude,
        longitude,
      });
    }, 10000),
  },
};
</script>
